const isObjectNullable = (obj: any) => {
  if (obj) {
    for (const key in obj) {
      if (
        obj[key] == "" ||
        obj[key] == null ||
        obj[key].toString().trim() == ""
      ) {
        return true;
      }
    }
    return false;
  } else {
    return true;
  }
};

export default isObjectNullable;
